import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { HOME_PATH } from '../../constants/sessionRoute.constants';
import { presentQueryValue } from '../../utils/confirmationAccess';

class RequireSearchParam extends React.Component {
  render() {
    const value = presentQueryValue(this.props.searchParams?.get(this.props.param));
    if (!value) return <Navigate to={HOME_PATH} replace />;
    return this.props.children;
  }
}

export function RequireSearchParamRoute({ param, children }) {
  const [searchParams] = useSearchParams();
  return (
    <RequireSearchParam param={param} searchParams={searchParams}>
      {children}
    </RequireSearchParam>
  );
}

export default RequireSearchParam;
